import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import { Heading, Stack, Text, TextLink } from 'braid-design-system';
import { Helmet } from 'react-helmet';
import { useTypedSelector } from 'src/reducers';
import getBrandSpecificDescription from 'src/utils/getBrandSpecificDescription';
import { ProfileVisibility } from './ProfileVisibility/ProfileVisibility';
import { useGetUrl } from '@seek/ca-myprofile-utils';
import { PageTitles } from '../Notifications/pageTitle';
import { SharedProfile } from './SharedProfile/SharedProfile';
import { useGetPageTitle } from 'src/utils/useGetPageTitle';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import { useEffect } from 'react';
import { useUserProfile } from '../Notifications/hooks/useUserProfile';
import { useMelwaysInfo } from '@seek/melways-react';

export const Visibility = () => {
  const site = useTypedSelector((state) => state.page.pageAnalytics.site);
  const brand = useTypedSelector((state) => state.page.pageAnalytics.brand);
  const zone = useTypedSelector((store) => store.page.pageAnalytics.zone);
  const { language } = useMelwaysInfo();
  const { t } = useTranslations(translations);
  const { user } = useUserProfile();
  const { trackPageLoad } = useAnalytics();

  useEffect(() => {
    if (user) {
      trackPageLoad({ currentPage: 'visibility settings' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // Disabling dependency on trackPageLoad to only track initial tab render

  const getUrl = useGetUrl(zone, language, true);
  const privacyUrl = getUrl('profile-privacy');

  const pageTitle = useGetPageTitle(site, language, 'Visibility Settings');

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content={getBrandSpecificDescription(site, language)}
        />
      </Helmet>
      <Stack space="gutter">
        <Heading level="4">{t('Where can my profile be seen?')}</Heading>
        <Stack space="small">
          <ProfileVisibility />
          <SharedProfile />
        </Stack>
        <Stack space="medium">
          <Text weight="medium">
            {t('Applications on BRAND', { brand: PageTitles[brand] })}
          </Text>
          <Text>
            {t('For all settings, your Profile including...', {
              TextLink: (children: React.ReactNode[]) => (
                <TextLink
                  key="privacyPolicyPath"
                  target="_blank"
                  href={privacyUrl}
                  hitArea="standard"
                  weight="weak"
                >
                  {children}
                </TextLink>
              ),
            })}
          </Text>
        </Stack>
      </Stack>
    </>
  );
};
